import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import settingsApi from "../../../data/api/settingsApi";
import { getAllSettings } from "../../../data/getters";
import { useLanguage } from "../../helpers/LanguageContext";

const INITIAL_SETTING = { name: "", value: "" };

export default function useSettingsPageController() {
  const dispatch = useDispatch();
  const { t } = useLanguage();
  const settings = useSelector((state) => state.settings || []);
  const [newSetting, setNewSetting] = useState(INITIAL_SETTING);
  const [error, setError] = useState("");

  const loadSettings = useCallback(
    () => dispatch(getAllSettings()),
    [dispatch]
  );

  useEffect(() => {
    loadSettings();
  }, [loadSettings]);

  const handleChange = useCallback((event) => {
    const { name, value } = event.target;
    setNewSetting((setting) => ({ ...setting, [name]: value }));
  }, []);

  const handleAddSetting = useCallback(async () => {
    const { name, value } = newSetting;
    if (!name.trim()) {
      setError(t("settingsErrorRequired"));
      return;
    }

    try {
      await dispatch(settingsApi.createSettingApi({ name, value }));
      await loadSettings();
      setNewSetting(INITIAL_SETTING);
      setError("");
    } catch (saveError) {
      console.error(t("settingsErrorSave"), saveError);
      setError(t("settingsErrorSave"));
    }
  }, [dispatch, loadSettings, newSetting, t]);

  return { t, settings, newSetting, error, handleChange, handleAddSetting };
}
